const DISCOVERY_LOCATION_STORAGE_KEY = 'artflow.discovery.position';

export const DEFAULT_DISCOVERY_POSITION = Object.freeze({
  lat: 34.0522,
  lng: -118.2437,
});

function isFiniteCoordinate(value) {
  return Number.isFinite(value);
}

function normalizePosition(value) {
  if (Array.isArray(value) && value.length === 2) {
    const [lat, lng] = value;
    if (isFiniteCoordinate(lat) && isFiniteCoordinate(lng)) {
      return { lat, lng };
    }
    return null;
  }

  if (value && typeof value === 'object') {
    const lat = Number(value.lat);
    const lng = Number(value.lng);
    if (isFiniteCoordinate(lat) && isFiniteCoordinate(lng)) {
      return { lat, lng };
    }
  }

  return null;
}

export function readStoredDiscoveryPosition() {
  try {
    const raw = window.localStorage.getItem(DISCOVERY_LOCATION_STORAGE_KEY);
    if (!raw) return null;
    return normalizePosition(JSON.parse(raw));
  } catch {
    return null;
  }
}

export function writeStoredDiscoveryPosition(value) {
  const normalized = normalizePosition(value);
  if (!normalized) return;

  try {
    window.localStorage.setItem(DISCOVERY_LOCATION_STORAGE_KEY, JSON.stringify(normalized));
  } catch {
    // Ignore storage failures and continue with in-memory state.
  }
}

export function getInitialDiscoveryPosition() {
  return readStoredDiscoveryPosition() || DEFAULT_DISCOVERY_POSITION;
}

export function toLeafletPosition(value) {
  const normalized = normalizePosition(value);
  if (!normalized) return null;
  return [normalized.lat, normalized.lng];
}
